import React from 'react';
import PropTypes from 'prop-types';
import { shouldCopyMacro } from '../../../util';
import { CopyButton as CommonCopyButton } from '../../common/buttonsComponents';
import { ToolTip } from 'components/common/tooltips';

export class CopyButton extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    selectedInboxTab: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    withEdge: PropTypes.bool,
  };

  state = {
    showCopySuccess: false,
  };

  getHoverText() {
    if (this.props.disabled) {
      return 'Fill in suggested';
    }

    return shouldCopyMacro(this.props.selectedInboxTab) ? 'Copy to text area' : 'Copy to clipboard';
  }

  getButtonText() {
    const useMacroText = this.props.withEdge ? 'USE MACRO & CONTINUE' : 'USE MACRO';
    const copyText = this.props.withEdge ? 'COPY MACRO & CONTINUE' : 'COPY MACRO';

    return shouldCopyMacro(this.props.selectedInboxTab) ? useMacroText : copyText;
  }

  render() {
    const buttonText = this.getButtonText();
    const hoverText = this.getHoverText();

    return (
      <ToolTip arrow placement="top" content={<div>{hoverText}</div>}>
        <CommonCopyButton
          disabled={this.props.disabled}
          onClick={() => {
            this.setState({ showCopySuccess: true });
            this.props.onClick();
            setTimeout(() => {
              this.setState({ showCopySuccess: false });
            }, 3000);
          }}
        >
          {this.state.showCopySuccess ? 'COPIED!' : buttonText}
        </CommonCopyButton>
      </ToolTip>
    );
  }
}
export default CopyButton;
